module.exports = __webpack_public_path__ + "media/music_39.48e46cbd.mp3";